import { openModal } from "action/modal/openModal";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import Text from "component/design-system/typography/Text";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import openLiveChat from "util/chat-widget/open-live-chat";
import styles from "./searchContactUs.module.scss";

const options = [
  {
    title: "CHAT NOW",
    subtitle: "chat_subtitle",
    tagLine: "Live chat",
    cssClass: "fa-comments",
  },
  {
    title: "EMAIL US",
    subtitle: "You can email us at",
    tagLine: "sales@partsavatar.ca",
    cssClass: "fa-envelope",
  },
  {
    title: "NOTIFY ME",
    subtitle: "notify_subtitle",
    tagLine: "Click to Comment",
    cssClass: "fa-bell",
  },
];

function SearchContactUs(props: any) {
  const dispatch = useDispatch();
  const { t } = useTranslation("category");
  const { title = t("search_contact_title") } = props;
  const { query } = useRouter();

  if (["rear-shocks-struts", "rear-shocks"].includes(query.pathname)) {
    return null;
  }

  function handleClick(type: any) {
    if (type === options[0].tagLine) {
      openLiveChat();
    }

    if (type === options[2].tagLine) {
      onClickTellUsMore();
    }
  }

  function onClickTellUsMore() {
    // props.onModalOpen("tellUsMore", {});
    dispatch(openModal("tellUsMore"));
  }

  return (
    <div className={styles.section_heading} style={{ marginTop: "calc(2 * var(--safari-root-font, 10px))" }}>
      <span className={styles.section_heading}>
        {title}
      </span>

      <div className="section row" style={{ paddingTop: "calc(2 * var(--safari-root-font, 10px))" }}>
        {options.map((item) => (
          <div key={item.title} className="text-padding col-sm-4">

            <div className={styles.icon_label}>

              <i className={`fa ${item.cssClass}`} />

              <Text bold size={4}>{t(item.title)}</Text>
            </div>

            <PAText component="span" fontSize={FONT_SIZE[0]} className={styles.sub_title} color="light-grey">{t(item.subtitle)}</PAText>

            <PAText inlineBlock fontSize={FONT_SIZE[2]} className={styles.tag_line} bold onClick={() => handleClick(item.tagLine)}>{t(item.tagLine)}</PAText>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SearchContactUs;
